import './css/App.css';
import NavBar from "./components/NavBar"
import WhaterPanel from "./components/WhaterPanel"

function App() {
  return (
    <div className="App">
      
        <NavBar/>
        <WhaterPanel/>
      
    </div>
  );
}

export default App;
